<script setup lang="ts">
import type { HomepageCategory } from './types'
import CategoryIcon from '~/components/Categories/CategoryIcon.vue'
import { useFilterStore } from '~/stores/useFilterStore'
import { Category, EnergySubCategory } from '~/types'

const props = defineProps<{
  data: HomepageCategory
}>()

const { isMobile } = useBreakpoint()
const router = useRouter()
const filterStore = useFilterStore()

const onClick = () => {
  if (props.data.disabled) return

  if (props.data.icon === Category.ELECTRICITY) {
    filterStore.setEnergySubCategory(EnergySubCategory.ELECTRICITY)
  } else if (props.data.icon === Category.GAS) {
    filterStore.setEnergySubCategory(EnergySubCategory.GAS)
  }

  router.push('/' + props.data.route)
}
</script>

<template>
  <button
    type="button"
    class="group flex flex-col items-center cursor-pointer focus-visible:ring-2 focus-visible:ring-current focus-visible:ring-offset-2 rounded-2xl"
    :class="{ 'opacity-50 cursor-not-allowed': data.disabled }"
    :aria-disabled="data.disabled ? 'true' : undefined"
    :aria-label="data.label"
    v-tooltip.top="{
      value: 'Coming soon',
      autoHide: false,
      disabled: !data.disabled,
    }"
    @click="onClick"
    @keydown.enter="onClick"
    @keydown.space.prevent="onClick">
    <!-- White rounded card -->
    <div class="flex flex-col items-center gap-2 px-3 py-4 sm:px-5 sm:py-5 rounded-2xl
                bg-white shadow-lg group-hover:shadow-2xl group-hover:scale-105
                transition-all duration-300 ease-out w-full">
      <!-- Gradient icon (vecchie icone ripristinate) -->
      <CategoryIcon
        :id="data.label"
        :icon="data.icon"
        :label="data.label"
        :size="isMobile ? 12 : 16"
        :gradient="true"
        :inverted="true"
      />
      <!-- Label - dark su sfondo bianco -->
      <p class="text-xs sm:text-sm font-bold text-center text-slate-700">
        {{ data.label }}
      </p>
    </div>
  </button>
</template>